export function omitNullAndUndefined(json) {
  return Object.fromEntries(
    Object.entries(json).filter(([key, value]) => value !== null && value !== undefined)
  );
}

function jsonToQueryString(json) {
  const jsonAfterRemovingUndefinedAndNull = omitNullAndUndefined(json);
  return (new URLSearchParams(jsonAfterRemovingUndefinedAndNull)).toString();
}

export const editPersonUrl = (userId) => `/users/${userId}/edit`;

export const personUrl = (wcaId) => `/persons/${wcaId}`;

export const personsUrl = `/persons`;
export const usersUrl = `/users`;

export const newResultUrl = (competitionId, roundId) => `/competitions/${competitionId}/admin/results/${roundId}/new`;
export const resultUrl = (id) => `/admin/results/${id}`;
export const editResultUrl = (id) => `/admin/results/${id}/edit`;

export const newScrambleUrl = (competitionId, roundId) => `/competitions/${competitionId}/admin/scrambles/${roundId}/new`;
export const scrambleUrl = (id) => `/admin/scrambles/${id}`;
export const editScrambleUrl = (id) => `/admin/scrambles/${id}/edit`;

export const competitionScrambleFilesUrl = (competitionId) => `/competitions/${competitionId}/scramble_files`;
export const scrambleFileUrl = (id) => `/scramble_files/${id}`;
export const scramblesUpdateRoundMatchingUrl = (competitionId) => `/competitions/${competitionId}/scramble_files/update-round-matching`;

export const postsUrl = (page, format = 'json') => {
  // In this case id holds the page number ;)
  return `/posts.${format}?page=${page}`;
};

export const submitPostUrl = `/posts`;

export const postUrl = (id) => `/posts/${id}`

export const updateTestVideoIdUrl = `/update-test-link`;
export const promoteTestVideoIdUrl = `/promote-test-link`;

export const incidentsUrl = (perPage, page, tags = undefined, searchString = undefined, competitions = undefined, format = 'json') => {
  const searchParams = new URLSearchParams(`per_page=${perPage}&page=${page}`);
  if (tags && tags.length > 0) {
    searchParams.append(`tags`, `${tags}`);
  }
  if (competitions) {
    searchParams.append(`competitions`, `${competitions}`);
  }
  if (searchString) {
    searchParams.append(`q`, searchString);
  }
   return `/incidents.${format}?${searchParams.toString()}`;
}

export const newIncidentUrl = `/incidents/new`;
export const incidentUrl = (id) => `/incidents/${id}`;

export const homepageUrl = `/`

export const createCompetitionUrl = `/competitions`;
export const competitionReportEditUrl = (id) => `/competitions/${id}/report/edit`;
export const editCompetitionsUrl = (id) => `/competitions/${id}/edit`;
export const competitionEditRegistrationsUrl = (id) => `/competitions/${id}/edit/registrations`;
export const competitionUrl = (id) => `/competitions/${id}`;
export const adminCompetitionUrl = (id) => `/competitions/${id}/edit/admin`;

export const competitionReportUrl = (id) => `/competitions/${id}/report`;

export const competitionApiUrl = (id) => `/api/v0/competitions/${id}`;

export const userRoleApiUrl = (id) => `/api/v0/user_roles/${id}`;

export const competitionEventResultsApiUrl = (id, eventId) => `/api/v0/competitions/${id}/results/${eventId}`;

export const competitionAllResultsUrl = (id, eventId) => `/competitions/${id}/results/all?event=${eventId}`;

export const competitionPreviewLiveResultsUrl = (id) => `/competitions/${id}/synced-results-preview`

export const omnisearchApiUrl = (query) => `/api/v0/search?q=${query}`;

export const competitionSearchApiUrl = (query) => `/api/v0/search/competitions?q=${query}`;

export const competitionEventScramblesApiUrl = (id, eventId) => `/api/v0/competitions/${id}/scrambles/${eventId}`;

export const competitionScramblesUrl = (id, eventId) => `/competitions/${id}/scrambles?event=${eventId}`;

export const adminCheckExistingResultsUrl = (competitionId) => `/competitions/${competitionId}/admin/check-existing-results`;

export const competitionEventsDataUrl = (id) => `/admin/events_data/${id}`;

export const adminFixResultsUrl = (personId, competition_id = undefined, event_id = undefined, round_type_id = undefined) => {
  const searchParams = new URLSearchParams(`person_id=${personId}`);

  if (competition_id) {
    searchParams.append(`competition_id`, competition_id);

    if (event_id) {
      searchParams.append(`event_id`, event_id);

      if (round_type_id) {
        searchParams.append(`round_type_id`, round_type_id);
      }
    }
  }

  return `/panel-page/fix-results?${searchParams.toString()}`
};

export const connectPaymentIntegrationUrl = (competitionId, paymentIntegration) => `https://www.worldcubeassociation.org/competitions/${competitionId}/payment_integration/${paymentIntegration}/connect`

export const paymentFinishUrl = (competitionId, paymentIntegration) => `https://www.worldcubeassociation.org/competitions/${competitionId}/payment-completion/${paymentIntegration}`

export const registrationPaymentsUrl = (registrationId) => `/api/v1/registrations/${registrationId}/payments`

export const registrationHistoryUrl = (registrationId) => `/api/v1/registrations/${registrationId}/history`;

export const refundPaymentUrl = (competitionId, paymentIntegration, paymentId) => `/competitions/${competitionId}/refund/${paymentIntegration}/${paymentId}`

export const paymentDenominationUrl = (registrationId, isoDonationAmount) => `/api/v1/registrations/${registrationId}/payment_denomination?iso_donation_amount=${isoDonationAmount}`

export const adminGenerateIds = `/persons/new_id`;

export const personApiUrl = (wcaId) => `/api/v0/persons/${wcaId}`;

export const userApiUrl = (id) => `/api/v0/users/${id}`;

export const personSearchApiUrl = (query) => `/api/v0/search/persons?q=${query}`;

export const userSearchApiUrl = (query) => `/api/v0/search/users?q=${query}`;

export const userAdminSearchApiUrl = (query) => `/users/admin_search?q=${query}`;

export const geocodingApiUrl = `/api/v0/geocoding/search`;
export const geocodingTimeZoneUrl = `/api/v0/geocoding/time_zone`;

export const competitionAnnouncementDataUrl = (competitionId) => `/competitions/${competitionId}/announcement_data`
export const competitionUserPreferencesUrl = (competitionId) => `/competitions/${competitionId}/user_preferences`
export const competitionConfirmationDataUrl = (competitionId) => `/competitions/${competitionId}/confirmation_data`
export const updateCompetitionConfirmationDataUrl = (competitionId) => `/competitions/${competitionId}/confirmation_data`

export const announceCompetitionUrl = (competitionId) => `/competitions/${competitionId}/announce`
export const cancelCompetitionUrl = (competitionId, undo = false) => `/competitions/${competitionId}/cancel?undo=${undo}`
export const closeRegistrationWhenFullUrl = (competitionId) => `/competitions/${competitionId}/close_full_registration`

export const updateUserNotificationsUrl = (competitionId) => `/competitions/${competitionId}/user_preference/notifications`

export const confirmCompetitionUrl = (competitionId) => `/competitions/${competitionId}/confirm`

export const competitionNearbyJsonUrl = `/competitions/edit/nearby-competitions-json`;

export const seriesEligibleCompetitionsJsonUrl = `/competitions/edit/series-eligible-competitions-json`;

export const registrationCollisionsJsonUrl = `/competitions/edit/registration-collisions-json`;

export const calculateDuesUrl = (countryId, currencyCode, baseEntryFee) => `/competitions/edit/calculate_dues?${jsonToQueryString({ countryId, currencyCode, baseEntryFee })}`;

export const adminPostingCompetitionsUrl = `/admin/posting-index.json`;

export const adminStartPostingUrl = `/admin/start-posting`;

export const clearResultsSubmissionUrl = (competitionId) => `/competitions/${competitionId}/admin/clear-submission`;

export const adminDeleteResultsDataUrl = (competitionId, roundId, model) => `/competitions/${competitionId}/admin/results-data?${jsonToQueryString({ roundId, model })}`;

export const adminCheckUploadedResults = (competitionId) => `/competitions/${competitionId}/admin/upload-results`;

export const fetchUserGroupsUrl = (groupType) => {
  const searchParams = new URLSearchParams();
  searchParams.append('groupType', groupType);
  return `/api/v0/user_groups?${searchParams.toString()}`;
};

export const addUserGroupsUrl = `/api/v0/user_groups`;

export const userGroupsUpdateUrl = (userGroupId) => `/api/v0/user_groups/${userGroupId}`;
export const fetchUserGroupUrl = (userGroupId) => `/api/v0/user_groups/${userGroupId}`;

export const countryBandsUrl = `/wfc/country-bands`;
export const subordinateDelegateClaimsUrl = `/panel/pending-claims`;
export const subordinateUpcomingCompetitionsUrl = `/competitions/for_senior`;
export const wfcCompetitionsExportUrl = `/wfc/competitions_export`;
export const generateDbTokenUrl = `/panel/generate_db_token`
export const sanityCheckResultsUrl = `/admin/sanity-check`

export const wfcXeroUsersUrl = `/api/v0/wfc/xero_users`;

export const wfcDuesRedirectsUrl = `/api/v0/wfc/dues_redirects`;

export const pendingClaimsUrl = (userId) => `/panel/pending-claims/${userId}`;

export const competitionsUrl = ({display, years, delegate, state}) => `/competitions?${jsonToQueryString({ display, years, delegate, state })}`;

export const competitionsForSeniorUrl = (userId) => `/competitions/for_senior/${userId}`;

export const userAvatarDataUrl = (userId) => `/users/${userId}/avatar`;

// Max number of objects fetched per query
export const WCA_API_PAGINATION = 25;

export const delegatesPageUrl = `/delegates`;

export const allDelegatePageUrl = `/delegates#all`;

export const teamsCommitteesPageUrl = (teamFriendlyId) => `/teams-committees#${teamFriendlyId}`;

export const officersAndBoardPageUrl = `/officers-and-board`;

export const translatorsPageUrl = `/translators`;

export const editUserAvatarUrl = (userId) => `/users/${userId}/edit?section=avatar`;
export const updateAvatarUrl = `/admin/avatars`;
export const getPendingAvatarUrl = `/admin/avatars/pending`;

export const contactUrl = `/contact`

export const contactEditProfileActionUrl = `/contact/edit_profile`

export const contactEditOthersProfileActionUrl = `/contact/edit_profile?editOthersProfile=true`

export const contactRecipientUrl = (contactRecipient) => `/contact?contactRecipient=${contactRecipient}`

export const contactCompetitionUrl = (competitionId, message) => `/contact?competitionId=${competitionId}&contactRecipient=competition&message=${message}`

export const apiV0Urls = {
  users: {
    me: {
      userDetails: `/api/v0/users/me`,
      permissions: `/api/v0/users/me/permissions`,
    },
    show: `/api/v0/users`
  },
  persons: {
    show: (wcaId) => `/api/v0/persons/${wcaId}`,
  },
  wrt: {
    edit: (wcaId) => `/api/v0/wrt/persons/${wcaId}`,
    destroy: (wcaId) => `/api/v0/wrt/persons/${wcaId}`,
    resetClaimCount: (wcaId) => `/api/v0/wrt/persons/${wcaId}/reset_claim_count`,
  },
  userRoles: {
    list: ({isActive, isGroupHidden, userId, groupId, status, groupType, isLead, page} = {}, sort, perPage = 100) => `/api/v0/user_roles?${jsonToQueryString({ sort, isActive, isGroupHidden, userId, groupId, status, groupType, isLead, page, per_page: perPage })}`,
    create: () => `/api/v0/user_roles`,
    update: (roleId) => `/api/v0/user_roles/${roleId}`,
    delete: (roleId) => `/api/v0/user_roles/${roleId}`,
    search: (query, groupType) => `/api/v0/user_roles/search?${jsonToQueryString({ query, groupType })}`,
  },
  userGroups: {
    list: (groupType, sort, {isActive, isHidden, parentGroupId, isRootGroup} = {}) => `/api/v0/user_groups?${jsonToQueryString({ groupType, sort, isActive, isHidden, parentGroupId, isRootGroup })}`,
  },
  competitions: {
    list: `/api/v0/competitions`,
    listIndex: `/api/v0/competition_index`,
    info: (compId) => `/api/v0/competitions/${compId}`,
    registrationData: `/api/v0/registration-data`
  },
  delegates: {
    searchIndex: `/api/v0/delegates/search-index`,
  },
}

export const panelUrls = {
  board: {
    regionsManager: `/panel/board#regions-manager`,
  },
  seniorDelegate: {
    regions: `/panel/senior_delegate#regions`,
  },
  wst: {
    translators: `/panel/wst#translators`,
  },
  leader: {
    groupsManager: `/panel/leader#groups-manager`,
  },
  wrt: {
    approveAvatars: `/panel/leader#approve-avatars`
  },
}

export const panelPageUrl = (panelPage, queryParams = {}) => `/panel-page/${panelPage}?${jsonToQueryString(queryParams)}`;

export const viewUrls = {
  tickets: {
    list: (type, status, sort) => `/tickets?${jsonToQueryString({ type, status, sort })}`,
    show: (ticketId) => `/tickets/${ticketId}`,
    listComments: (ticketId) => `/tickets/${ticketId}/ticket_comments`,
    listLogs: (ticketId) => `/tickets/${ticketId}/ticket_logs`,
    importedTemporaryResults: (competitionId) => `/tickets/imported_temporary_results?competition_id=${competitionId}`,
    importedTemporaryScrambles: (competitionId) => `/tickets/imported_temporary_scrambles?competition_id=${competitionId}`,
    inboxPersonSummary: (ticketId) => `/tickets/${ticketId}/inbox_person_summary`,
    eventsMergedData: (ticketId) => `/tickets/${ticketId}/events_merged_data`,
  },
  admin: {
    completePersons: (competitionIds) => `/admin/complete_persons?${jsonToQueryString({ competition_ids: competitionIds })}`,
    overrideRegionalRecords: (competitionId, eventId, refreshIndex) => `/admin/override_regional_records?check_regional_records_form[competition_id]=${competitionId}&check_regional_records_form[event_id]=${eventId}&check_regional_records_form[refresh_index]=${refreshIndex}`,
  },
  competitions: {
    countInRange: (startDate, endDate) => `/panel/competition_count?${jsonToQueryString({ startDate, endDate })}`,
    lastDuplicateCheckerJobRun: (competitionId) => `/competitions/${competitionId}/last-duplicate-checker-job`,
    newcomerNameFormatCheck: (competitionId) => `/competitions/${competitionId}/newcomer-name-format-check`,
    newcomerDobFormatCheck: (competitionId) => `/competitions/${competitionId}/newcomer-dob-check`,
    unfinishedPersons: (competitionId) => `/competitions/${competitionId}/unfinished-persons`,
    pendingResultsSubmissions: `/pending-results-submissions`,
  },
  persons: {
    results: (wcaId, competitionId, eventId) => `/persons/results?${jsonToQueryString({ wcaId, competitionId, eventId })}`,
  },
  cronjob: {
    details: (cronjobName) => `/panel/cronjob_details?cronjob_name=${cronjobName}`,
  },
  users: {
    showForEdit: (userId) => `/users/show_for_edit?id=${userId}`,
    showForMerge: (userId) => `/users/show_for_merge?id=${userId}`,
    rolesEditPage: (userId) => `/users/${userId}/edit?${jsonToQueryString({ section: "roles" })}`,
    pendingClaims: (wcaId) => `/persons/${wcaId}/pending_claims`,
  },
  helpfulQueries: {
    registrations: (userId) => `/users/registrations?${jsonToQueryString({ userId })}`,
    organizedCompetitions: (userId) => `/users/organized-competitions?${jsonToQueryString({ userId })}`,
    delegatedCompetitions: (userId) => `/users/delegated-competitions?${jsonToQueryString({ userId })}`,
    pastCompetitions: (userId) => `/users/past-competitions?${jsonToQueryString({ userId })}`,
  },
}

export const actionUrls = {
  tickets: {
    show: (ticketId) => `/tickets/${ticketId}.json`,
    editPersonValidators: (ticketId) => `/tickets/${ticketId}/edit_person_validators`,
    addComment: (ticketId) => `/tickets/${ticketId}/ticket_comments`,
    getDetailsBeforeAnonymization: (userId, wcaId) => `/tickets/details_before_anonymization?${jsonToQueryString({ userId, wcaId })}`,
    anonymize: `/tickets/anonymize`,
    verifyWarnings: (ticketId) => `/tickets/${ticketId}/verify_warnings`,
    mergeInboxResults: (ticketId) => `/tickets/${ticketId}/merge_inbox_results`,
    mergeInboxScrambles: (ticketId) => `/tickets/${ticketId}/merge_inbox_scrambles`,
    verifyNewcomers: (ticketId) => `/tickets/${ticketId}/verify_newcomers`,
    deleteInboxPersons: (ticketId) => `/tickets/${ticketId}/delete_inbox_persons`,
    postResults: (ticketId) => `/tickets/${ticketId}/post_results`,
    approveEditPersonRequest: (ticketId) => `/tickets/${ticketId}/approve_edit_person_request`,
    rejectEditPersonRequest: (ticketId) => `/tickets/${ticketId}/reject_edit_person_request`,
    createWcaIds: (ticketId) => `/tickets/${ticketId}/create_wca_ids`,
    editPersonFields: (ticketId) => `/tickets/${ticketId}/tickets_edit_person_fields`,
    editPersonField: (ticketId, editPersonFieldId) => `/tickets/${ticketId}/tickets_edit_person_fields/${editPersonFieldId}`,
    syncEditPersonRequest: (ticketId) => `/tickets/${ticketId}/sync_edit_person_request`,
    joinAsBccStakeholder: (ticketId) => `/tickets/${ticketId}/join_as_bcc_stakeholder`,
    eligibleRolesForBcc: (ticketId) => `/tickets/${ticketId}/eligible_roles_for_bcc`,
  },
  validators: {
    forCompetitionList: (competitionIds, selectedValidators, applyFixWhenPossible, checkRealResults) => `/panel/validators_for_competition_list?${jsonToQueryString({ competitionIds, selectedValidators, applyFixWhenPossible, checkRealResults })}`,
    forCompetitionsInRange: (startDate, endDate, selectedValidators, applyFixWhenPossible, checkRealResults) => `/panel/validators_for_competitions_in_range?${jsonToQueryString({ startDate, endDate, selectedValidators, applyFixWhenPossible, checkRealResults })}`,
  },
  competitionResultSubmission: {
    submitToWrt: (competitionId) => `/competitions/${competitionId}/submit-results`,
    uploadResultsJson: (competitionId) => `/competitions/${competitionId}/upload-json`,
    importWcaLiveResults: (competitionId) => `/competitions/${competitionId}/import-from-live`,
  },
  cronjob: {
    run: (cronjobName) => `/panel/cronjob_run?cronjob_name=${cronjobName}`,
    reset: (cronjobName) => `/panel/cronjob_reset?cronjob_name=${cronjobName}`,
  },
  competition: {
    computePotentialDuplicates: (competitionId) => `/competitions/${competitionId}/compute_potential_duplicates`,
    importRegistrations: (competitionId) => `/competitions/${competitionId}/registrations/import`,
    validateAndConvertRegistrations: (competitionId) => `/competitions/${competitionId}/registrations/validate_and_convert_registrations`,
  },
  users: {
    updateUserData: `/users/update_user_data`,
    merge: `/users/merge`,
    assignWcaId: `/users/assign_wca_id`,
    confirmWcaId: `/users/confirm_wca_id`,
  },
}

export const userPreferencesRoute = `/profile/edit?section=preferences`;

export const pollingRoute = (userId, competitionId) => `https://t7ni46t9jd.execute-api.us-west-2.amazonaws.com/v1/prod?competition_id=${competitionId}&user_id=${userId}`;

export const wcaRegistrationUrl = `https://registration.worldcubeassociation.org`;

export const getPsychSheetForEventUrl = (competitionId, eventId, sortBy) => `/api/v0/competitions/${competitionId}/psych-sheet/${eventId}?sort_by=${sortBy}`

export const editRegistrationUrl = (registrationId) => `/registrations/${registrationId}/edit`

export const eligibleVotersUrl = `/admin/all-voters`;

export const leaderSeniorVotersUrl = `/admin/leader-senior-voters`;

export const regionalVotersUrl = `/admin/regional-voters`;

export const confirmedRegistrationsUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registrations`;

export const allRegistrationsUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registrations/admin`;

export const singleRegistrationUrl = (registrationId) => `/api/v1/registrations/${registrationId}`;

export const getRegistrationConfigUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registration_config`;

export const registrationByUserUrl = (competitionId, userId) => `/api/v1/competitions/${competitionId}/registrations/${userId}`;

export const submitRegistrationUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registrations`;

export const updateRegistrationUrl = (registrationId) => `/api/v1/registrations/${registrationId}`;

export const bulkAutoAcceptUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registrations/bulk_auto_accept`;

export const bulkUpdateRegistrationUrl = (competitionId) => `/api/v1/competitions/${competitionId}/registrations/bulk_update`;

export const paymentTicketUrl = (registrationId, isoDonationAmount) => `/api/v1/registrations/${registrationId}/payment_ticket?iso_donation_amount=${isoDonationAmount}`;

export const uploadScramblesUrl = (competitionId) => `/competitions/${competitionId}/upload-scrambles`;

export const rankingsUrl = (eventId, rankingType, region, gender, show) => {
  const url = `/results/rankings/${eventId}/${rankingType}`
  const queryParams = new URLSearchParams();

  if (region !== 'world') {
    queryParams.append('region', region);
  }

  if (gender !== 'All') {
    queryParams.append('gender', gender);
  }

  if (show !== '100 persons') {
    queryParams.append('show', show);
  }

  return `${url}?${queryParams.toString()}`
};

export const serverStatusPageUrl = `/server-status`;

export const mergeProfilesUrl = `/panel-page/merge-profiles`;

export const recordsUrl = (eventId, region, gender, show) => {
  const url = `/results/records`
  const queryParams = new URLSearchParams();

  if (region !== 'world') {
    queryParams.append('region', region);
  }

  if (gender !== 'All') {
    queryParams.append('gender', gender);
  }

  if (eventId){
    queryParams.append('event_id', eventId)
  }

  if (show){
    queryParams.append('show', show)
  }

  return `${url}?${queryParams.toString()}`
};
